var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-up"},[_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.disabled}},[_vm._v(" ▲ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }